export default __webpack_public_path__ + "static/media/great-job.b5753f39.png";